import { getChannelMetadataFromControlUnitState } from '../../../redux/controlUnit/selectors/events';
import { ControlUnitState } from '../../../redux/controlUnit/slice/controlUnitSlice';
import { getTranslateManyDevicesFunction } from '../../../redux/CUTranslation/getTranslateFunction';
import { ShowLevelOption } from '../../../redux/groups/selectors/getLevelOfView';
import { toBase64 } from '../../../shared/util/base64';
import {
  TEMPERATURE_UNIT_TYPES,
  Temperature,
} from '../../temperaturePreference';
import { Sensordata, SensordataSTChartLine } from '../monitoring.model';
import { getLabelName } from './getLabelName';

export function mapSensordataToSTChartLine(
  sensordata: Sensordata,
  deviceId: string,
  commanderId: string,
  deviceName: string,
  CUsTranslate: ReturnType<typeof getTranslateManyDevicesFunction>,
  showLevelOption: ShowLevelOption,
  controlUnitState: ControlUnitState,
  temperaturePreference?: TEMPERATURE_UNIT_TYPES
): SensordataSTChartLine {
  const { values, unit, ...sensordataOtherData } = sensordata;
  const metadata = getChannelMetadataFromControlUnitState(
    controlUnitState.dictionaryControlUnit[deviceId]?.[sensordata.controlunit],
    sensordata.channel
  );
  const translatedName = CUsTranslate(
    metadata?.name ?? sensordata.channel ?? '',
    toBase64(commanderId) || deviceId || '',
    sensordata?.controlunit,
    'ram',
    'longText'
  ) as string;

  return {
    ...sensordataOtherData,
    deviceId,
    deviceName,
    name: getLabelName(
      showLevelOption,
      translatedName,
      sensordata.controlunitName,
      deviceName
    ),
    unit:
      temperaturePreference === TEMPERATURE_UNIT_TYPES.FAHRENHEIT ? '°F' : unit,
    data: values.map((value) => ({
      // Unix timestamp (seconds)
      timestamp: Math.floor(value.timestamp / 1000),
      val:
        temperaturePreference === TEMPERATURE_UNIT_TYPES.FAHRENHEIT
          ? Temperature.convertCelsiusToFahrenheitRound(value.value, 2)
          : value.value,
    })),
  };
}
